import _ from "lodash";
import { colors, createMuiTheme, responsiveFontSizes } from "@material-ui/core";
import typography from "./typography";

const baseOptions = {
  typography,
  overrides: {
    MuiToolbar: {
      regular: {
        minHeight: "0px !important",
        "@media (max-width: 1024px)": {
          minHeight: "70px !important",
        },
      },
    },

    MuiSlider: {
      root: {
        color: " #ffffff",
        height: "10px",
      },
      track: {
        height: "10px",
        borderRadius: "50px!important",
        backgroundColor: "#e21ae7 !important",
      },
      rail: {
        height: "10px",
        borderRadius: "50px!important",
        backgroundColor: "#e21ae7 !important",
        backgroundColor: "#fff",
        opacity: 1,
      },
      thumb: {
        width: "20px",
        height: "20px",
        "&.Mui-disabled": {
          width: "18px",
          height: "18px",
        },
      },
      valueLabel: {
        left: "calc(-50% - -3px)",
      },
      mark: {
        display: "none",
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "2px solid rgb(0 0 0)",
        backgroundColor: "#272a30",
        color: "#fff !important",
        padding: "5px 16px",
      },
    },
    PrivateValueLabel: {
      label: {
        color: " #000",
      },
    },
    MuiDialogContent: {
      root: {
        padding: 0,
        "&:first-child": {
          paddingTop: 0,
        },
      },
    },
    MuiFormLabel: {
      root: { color: "#222" },
      colorSecondary: {
        "&.Mui-focused": {
          color: "#222",
        },
      },
    },
    MuiList: {
      padding: {
        padding: "10px",
      },
    },
    MuiListSubheader: {
      root: {
        color: "#000000",
        fontSize: "22px !important",
        fontWeight: "600 !important",
        lineHeight: "33px !important",
      },
    },

    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: "rgb(235 13 202) !important",
        "&::placeholder": {
          color: "#fff",
        },
      },
      colorSecondary: {
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          color: "#fff",
          borderColor: "#222",
        },
        "&.Mui-focused": {
          color: "#ffff",
        },
      },
    },

    MuiCheckbox: {
      root: {
        padding: "4px",
        fontSize: "12px",
      },
      colorSecondary: {
        "&.Mui-checked": { color: "#000" },
      },
    },

    MuiButton: {
      containedPrimary: {
        backgroundColor: "#fff",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        background: " rgb(63,17,120)",
        background:
          "linear-gradient(39deg, rgba(63,17,120,1) 21%, rgba(139,70,191,1) 70%, rgba(255,0,204,1) 100%)",
        color: "#fff",
        fontSize: "15px",
        height: "50px",
        marginRight: "10px",
        borderRadius: "100px",
        textTransform: "uppercase",
        fontWeight: "bold",
        "@media (max-width: 767px)": {
          fontSize: "10px !important",
          height: "30px",
        },
        "&:hover": {
          background:
            "linear-gradient(101deg, rgba(63,17,120,1) 0%, rgba(63,17,120,1) 18%, rgba(63,17,120,1) 99%)",
        },
      },
      contained: {
        borderRadius: "50px",
        color: "#f30065",
        fontWeight: 600,
        padding: "11px 22px 7px",
        "&:hover": {
          backgroundColor: "#000",
          color: "#fff",
        },
      },
      outlinedPrimary: {
        borderRadius: "50px",
        color: "#d014c1",
        fontWeight: 600,
        padding: "5px 19px",
        border: "2px solid #d014c1",
        "&:hover": {
          backgroundColor: "#d014c1",
          border: "2px solid #d014c1",
          color: "#fff",
        },
      },
      outlinedSizeSmall: {
        padding: "6px 23px",
        fontSize: "16px",
        lineHeight: " 24px",
      },
    },
    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: "0",
      },
    },
    MuiMenu: {
      paper: { top: "47px" },
    },

    MuiTypography: {
      subtitle1: {
        color: "#000",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: " 16px",
        colorSecondary: {
          color: "#8d8989",
        },
      },
    },
  },
};

const themesOptions = {
  typography: {
    fontWeight: 400,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  palette: {
    type: "light",
    action: {
      primary: "#20509e",
    },
    background: {
      default: "#FBFBFD",
      dark: "#f3f7f9",
      paper: colors.common.white,
    },
    primary: {
      main: "#898989",
      dark: "#de0d0d",
      light: "#de0d0d",
    },
    secondary: {
      main: "#fff",
    },
    warning: {
      main: "#ffae33",
      dark: "#ffae33",
      light: "#fff1dc",
    },
    success: {
      main: "#54e18c",
      dark: "#54e18c",
      light: "#e2faec",
    },
    error: {
      main: "#ff7d68",
      dark: "#ff7d68",
      light: "#ffe9e6",
    },
    text: {
      primary: "#52565c",
      secondary: "#999999",
    },
    common: {
      black: "#222222",
    },
  },
};

export const createTheme = (config = {}) => {
  let theme = createMuiTheme(_.merge({}, baseOptions, themesOptions));

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
